export * from 'cf-core/src/images'
export const Hero404 = 'https://d24rddnpxh8ji7.cloudfront.net/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://d24rddnpxh8ji7.cloudfront.net/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/facebook_white.png'
export const instagram =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/instagram_white.png'
export const viewMenu =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1582589981/Kaido/viewMenu.png'
export const cflogo = 'https://d24rddnpxh8ji7.cloudfront.net/cflogo_black.png'
export const about =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/about.webp'
export const aboutParallel =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/aboutParallel.webp'
export const contactbg =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/footer.webp'
export const foodGallery =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/gallery.webp'
export const hero = 'https://d24rddnpxh8ji7.cloudfront.net/thericebox/hero.webp'
export const heroText =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/heroText.webp'
export const locationMap =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/map.webp'
export const locationMapPM =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/locationMap.webp'
export const logo =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/webLogo.webp'
export const mobileAbout =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/mobileAbout.webp'
export const mobileAboutParallel =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/mobileAboutParallel.webp'
export const mobileContactbg =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/mobileFooter.webp'
export const mobileGallery =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/mobileGallery.webp'
export const mobileHero =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/mobileHero.webp'
export const mobileHeroText =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/mobileHeroText2.webp'
export const mobileLogo =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/mobileLogo.webp'
export const mobileMap =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/mobileMap.webp'
export const mobilePromotion =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/mobilePromo2.webp'
export const orderPickupButton =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/onlineButton.webp'
export const caterButton =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/caterButton.webp'
export const promotions =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/promo2.webp'
export const mobileMenu = 'https://d119dh5sx3r8y4.cloudfront.net/viewMenu.webp'
export const viewMenuButton =
  'https://d24rddnpxh8ji7.cloudfront.net/thericebox/viewMenuButton.webp'

export { default as notice } from './notice.jpeg'
